<!-- Narrow screens: a "Change Year" button opens a full-screen grid of years,
     styled as the Archive grid in the primary navigation (Navigation/Archive/Grid.vue). Choosing
     a year goes to its page. Wider screens use the "Year" column instead (News/Archive.vue). -->

<template>
  <button class="trigger" type="button" :aria-expanded="isOpen" @click="isOpen = true">
    Change Year
  </button>
  <Teleport to="body">
    <div v-if="isOpen" class="year-sheet" role="dialog" aria-modal="true" aria-label="Year">
      <button class="close" type="button" aria-label="Close" @click="isOpen = false">✕</button>
      <fieldset>
        <legend>Year</legend>
        <menu>
          <li v-for="{year: each} in archive" :key="each">
            <router-link
              :to="`/news/${each}`"
              :class="{isSelected: each === year}"
              @click="isOpen = false">
              {{ each }}
            </router-link>
          </li>
        </menu>
      </fieldset>
    </div>
  </Teleport>
</template>

<script setup>
import {onMounted, ref} from "vue";
import {useEventListener} from "@vueuse/core";
import {fetchNewsArchive} from "@/composables/useNews";

defineProps({year: {type: String, required: true}});

const isOpen = ref(false);
const archive = ref([]);

onMounted(async () => {
  archive.value = await fetchNewsArchive();
});

useEventListener(window, "keydown", (event) => {
  if (event.key === "Escape" && isOpen.value) isOpen.value = false;
});
</script>

<style scoped>
/* the same pill as "Collapse all" (views/News/Index.vue .toggle-all) */
.trigger {
  appearance: none;
  -webkit-appearance: none;
  margin: 0;
  padding: 0.15rem 0.85rem;
  border: none;
  border-radius: 17px;
  box-shadow: none;
  background: #e8e8e8;
  color: #1a1a1a;
  font: inherit;
  font-size: 0.85em;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
  cursor: pointer;
}
.trigger:hover {
  background: white;
}
/* full screen, over the banner and the page */
.year-sheet {
  position: fixed;
  inset: 0;
  z-index: 101;
  overflow-y: auto;
  padding: 0.5rem 2rem 2rem;
  background: var(--background-color);
  font-size: 1.7rem; /* as the primary navigation's full-screen menu */
  font-weight: 700;
}
.close {
  display: block;
  margin: 0 0 0 auto;
  padding: 0.4rem;
  border: none;
  box-shadow: none;
  background: none;
  color: var(--primary-navigation-color, var(--text-color));
  font: inherit;
  cursor: pointer;
}
fieldset {
  margin: 0.3rem 0 0;
  padding: 0;
  border: 1px solid transparent;
  border-top-color: var(--primary-navigation-color, var(--text-color));
}
legend {
  margin: auto; /* centred, as the Archive grid */
  padding: 0 12px;
  color: var(--primary-navigation-color, var(--text-color));
}
menu {
  display: grid;
  grid-template-columns: repeat(4, auto);
  justify-content: space-between;
  row-gap: 1.2rem;
  margin: 1rem 0 0;
  padding: 0;
}
li {
  list-style: none;
}
a {
  color: var(--primary-navigation-color, var(--text-color));
  text-decoration: none;
}
a.isSelected {
  color: var(--brand-color);
}
</style>
